import { FunctionComponent, lazy, Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';

import {
	FeatureFlagProvider,
	NotificationsProvider,
} from '@mopla/business-logic';
import { driverTheme } from '@mopla/mui';
import { StatusBarStyleSyncProvider, useOverlayingWebView } from '@mopla/ui';
import { NetworkStatusProvider, shouldEnableDevUtils } from '@mopla/utils';

import { environment } from '../environments/environment';

import EmergencyStatusProvider from './contexts/EmergencyContext';
import AppRoutes from './routes/AppRouter';

const FeatureFlagDevHelper = lazy(
	() => import('../components/FeatureFlagDevHelper')
);

const ViewEntrypoint: FunctionComponent = () => {
	useOverlayingWebView();

	const shouldAddDevUtils = shouldEnableDevUtils(environment.env);

	return (
		<NotificationsProvider>
			<NetworkStatusProvider>
				{/**Note: featureFlag FeatureFlagProvider is added here for the driver app because of shared MplPageHeader component */}
				<FeatureFlagProvider>
					{shouldAddDevUtils && (
						<Suspense fallback={null}>
							<FeatureFlagDevHelper />
						</Suspense>
					)}
					<ThemeProvider theme={driverTheme}>
						<EmergencyStatusProvider>
							<StatusBarStyleSyncProvider>
								<AppRoutes />
							</StatusBarStyleSyncProvider>
						</EmergencyStatusProvider>
					</ThemeProvider>
				</FeatureFlagProvider>
			</NetworkStatusProvider>
		</NotificationsProvider>
	);
};

export default ViewEntrypoint;
